/**
 * Program: regex directive
 * Author: SDL
 * Description: Constraint through Regular Equation
 */
/* eslint-disable no-unused-vars */
export default {
    bind(el, binding, vnode) {
        // console.log('bind', el, binding, vnode);
        el.addEventListener('keyup', () => {
            let rep = (v) => { return v.replace(eval(binding.value), ''); }
            el.value = rep(el.value);
        });
    },
};



// WEBPACK FOOTER //
// ./src/directives/regex.js